import * as React from 'react'

import { NoticeBox } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { message } from 'modules/goals/lib/getGoalBanner'
import type GoalConfig from 'modules/goals/store/models/GoalConfig'
import { STATUS } from 'modules/goals/store/models/GoalConfig'

interface BannerProps {
  goalConfig: GoalConfig
}

const Banner = ({ goalConfig }: BannerProps) => {
  if (!goalConfig) return null

  const color = (status: string) => {
    switch (status) {
      case STATUS.closed:
        return 'radicalRed100'

      case STATUS.active:
      default:
        return 'lime200'
    }
  }

  return (
    <NoticeBox
      message={message(goalConfig.attributes.status)}
      color={color(goalConfig.attributes.status)}
      justifyContent="center"
    />
  )
}

export default observer(Banner)
